import {
    Typography,
    Container,
    Grid,
    Card,
    CardHeader,
    Link,
    Stack
} from '@mui/material'
import { useTranslation } from 'react-i18next';

import Iconify from '../components/Iconify';
import BreadcrumbsMenu from '../components/BreadcrumbsMenu';
import LanguageSwitcher from '../components/LanguageSwitcher';
import IRPCalculatorForm from '../components/IRPCalculator';
import IRPTable from '../components/IRPTable';

import Page from '../components/Page'

export default function IRPCalculatorPage() {
    const { t } = useTranslation();

    return (
        <Page>

            <Container maxWidth="lg" spacing={1} >
              <br />

              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                spacing={1}
              >
                <BreadcrumbsMenu />
                <LanguageSwitcher />
              </Stack>
              
              <Grid container spacing={3} sx={{pt: 3, pb: 3}}>
                <Grid item xs={12} md={4}>

                  <Card sx={{ p: 2 }}>
                      <CardHeader title={t('table.title')}/>
                      <IRPTable />
                      <br />
                      <Stack direction="row" alignItems="center">
                        <Iconify icon={'gg:info'} width={16} height={16} />
                        &nbsp;
                        <Typography variant="caption">
                          {t('info.moreInfo')}&nbsp;
                          <Link underline="hover" 
                                href="https://www.conta.com.py/post/impuesto-a-la-renta-personal-irp-conceptos-basicos" 
                                target="_blank">{t('info.linkText')}</Link>.
                        </Typography>
                      </Stack>
                      <br />
                      <Stack direction="row" alignItems="center">
                        <Iconify icon={'emojione:warning'} width={16} height={16} />
                        &nbsp;
                        <Typography variant="caption">
                          <strong>{t('info.noteLabel')}</strong>
                        </Typography>
                      </Stack>
                      
                      <Stack direction="row" alignItems="center">
                        <Typography variant="caption">
                          {t('info.noteBody')}
                        </Typography>
                      </Stack>
                  </Card>

                </Grid>
                
                <Grid item xs={12} md={8}>
                  <Card sx={{ pl: 2, pr: 2, pb: 2}} >
                    
                    <IRPCalculatorForm />
                    
                  </Card>
                </Grid>
              </Grid>
            </Container>
        </Page>
        
    );
}
